module.exports = __webpack_public_path__ + "img/P150T_weapon_151.a668a8db.png";